import axiosInstance from '../axios/axios-instance';
import {
  NotificationInboxResponseDto,
  NotificationPreferencesDto,
} from 'shared/interfaces/notifications/notification.interface';

export interface SerializedPushSubscription {
  endpoint: string;
  expirationTime?: number | null;
  keys: {
    p256dh: string;
    auth: string;
  };
}

export interface BrowserNotificationPreferenceResponse {
  enabled: boolean;
  promptDismissed: boolean;
  pointsAwarded: number;
  rewardAlreadyClaimed: boolean;
}

export const notificationsApi = {
  async getInbox(cursor?: string, limit = 20): Promise<NotificationInboxResponseDto> {
    const response = await axiosInstance.get<NotificationInboxResponseDto>('/notifications/inbox', {
      params: { cursor, limit },
    });
    return response.data;
  },

  async getUnreadCount(): Promise<number> {
    const response = await axiosInstance.get<{ unreadCount: number }>('/notifications/unread-count');
    return response.data.unreadCount;
  },

  async markRead(notificationId: number): Promise<void> {
    await axiosInstance.post(`/notifications/${notificationId}/read`);
  },

  async markAllRead(): Promise<void> {
    await axiosInstance.post('/notifications/read-all');
  },

  async markActioned(notificationId: number): Promise<void> {
    await axiosInstance.post(`/notifications/${notificationId}/actioned`);
  },

  async markOpened(notificationId: number): Promise<void> {
    await axiosInstance.post(`/notifications/${notificationId}/opened`);
  },

  async getPreferences(): Promise<NotificationPreferencesDto> {
    const response = await axiosInstance.get<NotificationPreferencesDto>('/notifications/preferences');
    return response.data;
  },

  async updatePreferences(preferences: NotificationPreferencesDto): Promise<NotificationPreferencesDto> {
    const response = await axiosInstance.put<NotificationPreferencesDto>('/notifications/preferences', preferences);
    return response.data;
  },

  async getVapidPublicKey(): Promise<string | null> {
    const response = await axiosInstance.get<{ publicKey: string | null }>('/notifications/vapid-public-key');
    return response.data.publicKey;
  },

  async updateBrowserNotifications(
    enabled: boolean,
    subscription?: SerializedPushSubscription | null
  ): Promise<BrowserNotificationPreferenceResponse> {
    const response = await axiosInstance.post<BrowserNotificationPreferenceResponse>('/notifications/browser', {
      enabled,
      subscription,
    });
    return response.data;
  },

  async dismissBrowserNotificationPrompt(): Promise<void> {
    await axiosInstance.post('/notifications/browser/dismiss-prompt');
  },
};
